import { FunctionalComponent } from 'preact'
import Button from '@insided/control/uikit/Button'
import { Categories } from '.'
import { getTitleForCategoryId, normalizeCategoriesAndGroups } from '@insided/control/uikit/CategorySelector/utils'

// eslint-disable-next-line import/no-internal-modules
import DropdownControl from '@insided/deprecated-preact-components/dropdown/DropdownControl'

export interface CategorySelectorProps {
  categories: Categories
  categoryId: number | null
  onUpdate: (categoryId: number) => void
}

const CategorySelector: FunctionalComponent<CategorySelectorProps> = ({ categories, categoryId, onUpdate }) => {
  const normalizedCategoriesAndGroups = normalizeCategoriesAndGroups(categories, onUpdate)
  const title = getTitleForCategoryId(normalizedCategoriesAndGroups, categoryId)
  return (
    <div className='category-selectize-wrapper'>
      <DropdownControl
        align='adjust'
        trigger={<Button title={title} endIcon='chevronDown' size='medium' fullWidth data-qa='select-category' />}
        items={normalizedCategoriesAndGroups}
        fullWidth
        newStyle
        closeOnDropdownClick
      />
    </div>
  )
}

export default CategorySelector
